module.exports = __webpack_public_path__ + "img/heat-cost-allocator-sm.c5f78abb.svg";